import { BreadcrumbListComponent } from '@aipb/gulliver/dynamic-gallery/ui';
import { SimpleCardComponent } from '@aipb/shared/ui/card';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgxMasonryModule } from 'ngx-masonry';
import { CollectionCoverComponent, CollectionListComponent, CollectionToolbarComponent } from './components';
import { CollectionComponent } from './components/collection/collection.component';

@NgModule({
  declarations: [CollectionCoverComponent, CollectionListComponent, CollectionToolbarComponent, CollectionComponent],
  imports: [
    CommonModule,
    LazyLoadImageModule,
    NgxMasonryModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    SimpleCardComponent,
    FontAwesomeModule,
    BreadcrumbListComponent
  ],
  exports: [CollectionComponent]
})
export class DynamicGalleryFeatureCollectionModule {}
